const UserType = Object.freeze({
    RETAIL: 'RETAIL',
    WHOLESALE: 'WHOLESALE',
    CALLCENTER: 'CALLCENTER',
    UNDEFINED: 'UNDEFINED',
  });
  
  export default UserType;